import { createContext, useContext, type ReactNode } from 'react';

/**
 * Переход к оплате из любого места (T12.6, `09_UI_UX.md` §8).
 *
 * Экран оплаты открывается в момент упора в лимит, а упереться можно
 * где угодно: при создании подписки, при попытке сравнить площадки, при
 * загрузке любого списка — отказ по тарифу приходит от сервера и
 * разбирается общим `renderFailure`. Протаскивать обработчик через
 * каждый экран значило бы добавить довод восьми составляющим ради
 * одного действия, и первый же новый экран о нём забыл бы.
 *
 * ## Почему это единственный контекст в приложении
 *
 * Контекст оправдан там, где значение нужно многим и не принадлежит
 * никому. Здесь так и есть: «открыть оплату» — свойство приложения, а
 * не экрана. Всё остальное — данные экрана, и они ходят доводами.
 *
 * ## Без обёртки — не отказ, а бездействие
 *
 * Значение по умолчанию ничего не делает. Показ состояний (T11.3)
 * рисует `LimitState` вне приложения, и падать там не за что: кнопка
 * образца не обязана вести к оплате.
 */

const UpgradeContext = createContext<() => void>(() => undefined);

export function UpgradeProvider({
  onUpgrade,
  children,
}: {
  onUpgrade: () => void;
  children: ReactNode;
}): React.JSX.Element {
  return <UpgradeContext.Provider value={onUpgrade}>{children}</UpgradeContext.Provider>;
}

/** Открыть экран оплаты. */
export function useUpgrade(): () => void {
  return useContext(UpgradeContext);
}
